import { job_field, academic_field } from "../../static/static_field";

const formFields = [
  {
    key: "name_cn",
    label: "姓名",
    type: "input",
    disabled: true,
  },
  {
    key: "pub_email",
    label: "邮箱",
    type: "input",
    privacy_control_key: "p_pub_email",
  },
  {
    key: "phone",
    label: "电话",
    type: "input",
    privacy_control_key: "p_phone",
  },
  {
    key: "wechat_id",
    label: "微信ID",
    type: "input",
    privacy_control_key: "p_wechat_id",
  },
  {
    key: "linkedin",
    label: "领英",
    type: "input",
    privacy_control_key: "p_linkedin",
  },
  {
    key: "homepage_link",
    label: "主页链接",
    type: "input",
    privacy_control_key: "p_homepage_link",
  },
  {
    key: "other_contact",
    label: "其他联系方式",
    type: "input",
    privacy_control_key: "p_other_contact",
  },
  {
    key: "loc_country",
    label: "国家",
    type: "input",
    privacy_control_key: "p_loc",
  },
  {
    key: "loc_city",
    label: "地区/城市",
    type: "input",
    privacy_control_key: "p_loc",
  },
  {
    key: "cp_career",
    label: "职业",
    type: "checkbox",
  },
  {
    key: "cp_academic",
    label: "学术",
    type: "checkbox",
  },
  {
    key: "cp_local_gather",
    label: "当地聚会",
    type: "checkbox",
  },
  {
    key: "cp_dating",
    label: "约会",
    type: "checkbox",
  },
  {
    key: "school1",
    label: "学校名称",
    type: "input",
    privacy_control_key: "p_school1",
  },
  {
    key: "school2",
    label: "学校名称",
    type: "input",
    privacy_control_key: "p_school2",
  },
  {
    key: "school3",
    label: "学校名称",
    type: "input",
    privacy_control_key: "p_school3",
  },
  {
    key: "school4",
    label: "学校名称",
    type: "input",
    privacy_control_key: "p_school4",
  },
  {
    key: "employer",
    label: "雇主",
    type: "input",
    privacy_control_key: "p_career",
  },
  {
    key: "job_field",
    label: "工作领域",
    type: "select",
    options: job_field.map(item => ({
      value: item.value,
      label: item.label,
    })),
    privacy_control_key: "p_career",
  },
  {
    key: "job_desc",
    label: "工作描述",
    type: "input",
    privacy_control_key: "p_career",
  },
  {
    key: "misc_text",
    label: "其他信息",
    type: "input",
  },
];

const educationHistory = [
  // Middle School Information
  {
    key: "schoolm",
    label: "初中",
    type: "input",
    disabled: true,
  },
  {
    key: "schoolm_class",
    label: "初中班级",
    type: "input",
    disabled: true,
  },
  {
    key: "schoolm_start_time",
    label: "初中入学时间",
    type: "input",
    disabled: true,
  },
  {
    key: "schoolm_end_time",
    label: "初中结束时间",
    type: "year",
  },
  // High School Information
  {
    key: "schoolh",
    label: "高中",
    type: "input",
  },
  {
    key: "schoolh_class",
    label: "高中班级",
    type: "input",
  },
  {
    key: "schoolh_start_time",
    label: "高中入学时间",
    type: "year",
  },
  {
    key: "schoolh_end_time",
    label: "高中结束时间",
    type: "year",
  },
  {
    key: "school1_end_time",
    label: "结束时间",
    type: "year",
  },
  {
    key: "school1_level",
    label: "学位",
    type: "select",
    options: academic_field.map(item => ({
      value: item.value,
      label: item.label,
    })),
  },
  {
    key: "school1_major",
    label: "专业",
    type: "input",
  },
  {
    key: "school1_start_time",
    label: "入学时间",
    type: "year",
  },
  {
    key: "school2_end_time",
    label: "结束时间",
    type: "year",
  },
  {
    key: "school2_level",
    label: "学位",
    type: "select",
    options: academic_field.map(item => ({
      value: item.value,
      label: item.label,
    })),
  },
  {
    key: "school2_major",
    label: "专业",
    type: "input",
  },
  {
    key: "school2_start_time",
    label: "入学时间",
    type: "year",
  },
  {
    key: "school3_end_time",
    label: "结束时间",
    type: "year",
  },
  {
    key: "school3_level",
    label: "学位",
    type: "select",
    options: academic_field.map(item => ({
      value: item.value,
      label: item.label,
    })),
  },
  {
    key: "school3_major",
    label: "专业",
    type: "input",
  },
  {
    key: "school3_start_time",
    label: "入学时间",
    type: "year",
  },
  {
    key: "school4_end_time",
    label: "结束时间",
    type: "year",
  },
  {
    key: "school4_level",
    label: "学位",
    type: "select",
    options: academic_field.map(item => ({
      value: item.value,
      label: item.label,
    })),
  },
  {
    key: "school4_major",
    label: "专业",
    type: "input",
  },
  {
    key: "school4_start_time",
    label: "入学时间",
    type: "year",
  },
];

const contactPreferences = [
  {
    key: "cp_academic",
    label: "学术沟通（科研，选校，选专业等）",
    type: "input",
  },
  {
    key: "cp_career",
    label: "职业沟通（行业资源，工作内推等）",
    type: "input",
  },
  {
    key: "cp_local_gather",
    label: "参加/组织当地校友聚会",
    type: "input",
  },
  {
    key: "cp_dating",
    label: "个人情感",
    type: "input",
  },
];

export { formFields, educationHistory, contactPreferences };
